import { MasterData } from '../../../utils/type';
import { GridType, VanishType, VesselTopType } from './tubeChartTypes';

export const onCLickValues:MasterData[] = [
  { Value: VanishType.None, Text: VanishType.None },
  { Value: VanishType.Down, Text: VanishType.Down },
  { Value: VanishType.Top, Text: VanishType.Top },
  { Value: VanishType.Left, Text: VanishType.Left },
  { Value: VanishType.Right, Text: VanishType.Right },
  { Value: VanishType.Individual, Text: VanishType.Individual },
];
export const vesselTopValues:MasterData[] = [
  { Value: VesselTopType.Up, Text: VesselTopType.Up },
  { Value: VesselTopType.Down, Text: VesselTopType.Down },
  { Value: VesselTopType.Right, Text: VesselTopType.Right },
  { Value: VesselTopType.Left, Text: VesselTopType.Left },
  { Value: VesselTopType.East, Text: VesselTopType.East },
  { Value: VesselTopType.West, Text: VesselTopType.West },
  { Value: VesselTopType.North, Text: VesselTopType.North },
  { Value: VesselTopType.South, Text: VesselTopType.South },
  { Value: VesselTopType.NorthEast, Text: VesselTopType.NorthEast },
  { Value: VesselTopType.NorthWest, Text: VesselTopType.NorthWest },
  { Value: VesselTopType.SouthEast, Text: VesselTopType.SouthEast },
  { Value: VesselTopType.SouthWest, Text: VesselTopType.SouthWest },
];

export const gridTypeValues:MasterData[] = [
  { Value: GridType.LeftEccentric, Text: GridType.LeftEccentric },
  { Value: GridType.TopEccentric, Text: GridType.TopEccentric },
  { Value: GridType.Normal, Text: GridType.Normal },
];

export const sectionValues:MasterData[] = [
  { Value: '1', Text: 'Section 1' },
  { Value: '2', Text: 'Section 2' },
  { Value: '3', Text: 'Section 3' },
];

export const offsetList = {
  2: 'normal',
  0: 'leftEccentric',
  1: 'topEccentric',
};

export enum TubeChartPanelNames {
  Section = 'section',
  OnClick = 'onClick',
  VesselTop = 'vesselTop',
  ChartSize = 'chartSize',
  TubeCount = 'tubeCount',
  TotalTubeCount = 'totalTubeCount',
  Size = 'size',
  Zoom = 'zoom',
}
